export const SET_DATA_SEARCH = "SET_DATA_SEARCH";
export const SET_IMAGE_KPI = "SET_IMAGE_KPI";
